import { render, staticRenderFns } from "./userLogin.vue?vue&type=template&id=57396efc&scoped=true&"
import script from "./userLogin.vue?vue&type=script&lang=ts&"
export * from "./userLogin.vue?vue&type=script&lang=ts&"
import style0 from "./userLogin.vue?vue&type=style&index=0&id=57396efc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57396efc",
  null
  
)

export default component.exports